import * as React from 'react';
import { toast } from 'react-toastify';

interface DriverJobsSiteDepartureSkipProps {
    notes: string;
    saveDisabled: boolean;
    back(): void;
    update(notes: string): void;
    save(): void;
}

const DriverJobsSiteDepartureSkipData = (props: DriverJobsSiteDepartureSkipProps) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const back = (e: any) => {
        e.preventDefault();

        props.back();
    }

    const handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errorList = errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }
        setErrors(errorList);
        
        props.update(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!props.notes) {
            formIsValid = false;
            errorList["notes"] = "Reason is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.save();
        } else {
            toast.error("Fix validation errors on screen before going Next");
        }
    }

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <div className="makeitflexspacebetween marginBottom10">
                    <h2 className="mobile-margin">Can't Do Job</h2>
                    <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => back(e)}></i>
                </div>

                <span className="makeitred makeitbold">Call your supervisor to let them know why you can't do this job so they can reschedule.</span>

                <label className="input-group marginTop10" htmlFor="notes">
                    <span className="label-mobile">Enter reason why you can't do the job</span>
                    <textarea className="input marginLeft0 job__noteSize label-mobile" id="notes" name="notes" value={props.notes} onChange={(e) => handleChange(e)}></textarea>
                </label>
                <span className={errors["notes"] ? "label errors" : "hidden"}>{errors["notes"]}</span>

                <div className="defaultbutton__container--right marginTop10">
                    <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (props.saveDisabled ? " mobile-image-button--disabled" : "")} onClick={(e) => save(e)}></i>
                </div>
            </div>
        </div>
    );
}

export default DriverJobsSiteDepartureSkipData;